module.exports = __webpack_public_path__ + "static/grid-f-4e8a4b639aea20310cd1e18539c895dc.jpg";